module.exports = __webpack_public_path__ + "img/explode_view.9e580541.png";